import {companyData} from '../../global/change-company';
import {GeneralCapexVersions} from './versions/general-capex-versions';

const isCorporate = companyData.id === 1;
const pendingFilter = {
    filters: [], logic: 'or', forField: 'pendingApprovals'
};
const myCreatedFilter = {
    filters: [], logic: 'and', forField: 'originator'
};
const filterRoles = [];

let reqGrid;
let extraFiltersInitialized = false;
let reqGridInitialized = false;
let createWindowInitialized = false;

new kendo.data.Model.define({
    id: 'order', fields: {
        role         : {
            type: 'string', editable: false
        }, order     : {
            type: 'number', editable: false
        }, isApproved: {
            type: 'boolean', editable: false
        }, approvedBy: {
            type: 'string', editable: false
        }, approvedOn: {
            type: 'date', editable: false
        }
    }
});

const reqGridModel = new kendo.data.Model.define({
    id: 'uid', fields: {
        uid                : {
            type: 'string', editable: false
        }, category        : {
            type: 'string', editable: false
        }, requestId       : {
            type: 'number', editable: false
        }, displayId       : {
            type: 'string', editable: false
        }, requestDate     : {
            type: 'date', editable: false
        }, companyId       : {
            type: 'number', editable: false
        }, companyName     : {
            type: 'string', editable: false
        }, originator      : {
            type: 'string', editable: false
        }, details         : {
            type: 'string', editable: false
        }, total           : {
            type: 'number', editable: false
        }, budget          : {
            type: 'number', editable: false
        }, isRejected      : {
            type: 'bool', editable: false
        }, rejectedBy      : {
            type: 'string', editable: false
        }, approvals       : {
            type: 'object', editable: false
        }, pendingApprovals: {
            type: 'string', editable: false
        }, status          : {
            type: 'string', editable: false
        }
    }
});

const getSortValue = (item) => {
    let sortValue = item.approvals.filter(a => a.isApproved).length;
    const isApproved = item.status === 'Approved';
    if (isApproved) {
        sortValue += 50;
    }
    if (item.isRejected && !isApproved) {
        sortValue += 25;
    }
    return sortValue;
};

const reqGridDs = new kendo.data.DataSource({
    transport  : {
        read: {
            url: '/Finance/CapitalExpenditures/GetRequests', dataType: 'json', data() {
                return {
                    branchId: companyData.id
                };
            }
        }
    }, schema  : {
        model: reqGridModel, parse(r) {
            if (r.length <= 0) return r;
            for (const item of r) {
                item.approvals = JSON.parse(item.approvals);
                item.pendingApprovals = '';
                for (const approval of item.approvals) {
                    if (!approval.isApproved && !item.isRejected) {
                        if (approval.role === 'CEO') {
                            let totalLimit = 25000;
                            if (item.total >= totalLimit && item.category !== 'Vehicle') {
                                item.pendingApprovals += 'CEO,';
                            }
                        } else {
                            item.pendingApprovals += approval.role + ',';
                        }
                    }

                    if (new Date(item.requestDate) < GeneralCapexVersions.version2) {
                        if (item.category === 'General') {
                            const approvalIndex = item.approvals.indexOf(approval);
                            item.approvals.splice(approvalIndex, 1);
                        }
                    }

                }
                let catId;
                switch (item.category) {
                    case 'General':
                        catId = 'CAPEX';
                        break;
                    case 'Technology':
                        catId = 'TECH';
                        break;
                    case 'Vehicle':
                        catId = 'VEHICLE';
                        break;
                    default:
                        catId = 'UNK';
                        break;
                }
                item.displayId = `${catId}-${String(item.requestId).padStart(6, '0')}`;
            }
            r.sort((x, y) => getSortValue(x) - getSortValue(y));
            return r;
        }
    }, pageSize: 20
});

const requestStatusTemplate = (di) => {
    const rejectionTag = `<div class="tag tag--small-x tag--blue">${di.rejectedBy}</div>`;
    const tags = ['<div class="capex-approval-wrapper">'];
    for (const approval of di.approvals) {
        const tag = getApprovalTag(approval);

        // only add the tag to display later if the row isn't reject
        // if it is rejected, only display the tag if it's also approved
        if (!di.isRejected) tags.push(tag); else if (approval.isApproved) tags.push(tag);
    }
    if (di.isRejected) { // add rejection tag if needed
        tags.push(rejectionTag);
    }
    tags.push('</div>');
    return tags.join('\r\n'); // return all valid tags for display
};

const getApprovalTag = (approval) => {
    const approved = Boolean(approval.isApproved);
    const tagClass = approved ? 'tag--green' : 'tag--red', tagText = approved ? approval.approvedBy : approval.role;
    return `<div class="tag tag--small-x ${tagClass}">${tagText}</div>`;
};

const reqGridColumns = [
    {
        field   : 'displayId', title: 'Request ID', filterable: {
            ui(element) {
                element.kendoAutoComplete({
                    dataSource: ['CAPEX', 'TECH', 'VEHICLE'], minLength: 0
                });
            }
        }, width: '150px'
    }, {
        field: 'requestDate', title: 'Created On', attributes: {style: 'text-align: right'}, format: '{0:M/d/yyyy}', width: '120px'
    }, {
        field: 'companyName', title: 'Branch', width: '125px', hidden: !isCorporate
    }, {
        field: 'originator', title: 'Requested By'
    }, {
        field: 'details', title: 'Request Details', template(di) {
            const regEx = new RegExp('\r\n', 'g');
            return di.details.replace(regEx, '<br>');
        }
    }, {
        field   : 'total', title: 'Cost', attributes: {style: 'text-align: right'}, template(di) {
            const budget = di.budget ?? 0.0;
            const total = di.total ?? 0.0;
            const overBudget = total > budget;
            const overBudgetClass = overBudget ? 't-red' : '';
            const totalStr = kendo.format('{0:c}', total) + (overBudget ? ' ' : '');
            return `<div><span class="whitespace-break-spaces ${overBudgetClass}">${totalStr}</span></div>`;
        }, width: '125px'
    }, {
        field: 'status', title: 'Request Status', template: requestStatusTemplate
    }
];

const openRequest = (e) => {
    const dre = $(e.target).closest('tr[role="row"]');
    const dr = reqGrid.dataItem(dre);
    $.redirect({
        url      : `/Finance/CapitalExpenditures/${dr.category}Request`, values: {
            RequestNumber: dr.requestId
        }, target: '_blank'
    });
};

const reqGridDataBound = (e) => {
    const grid = e.sender;
    const rows = $(grid.element).find('table[role="grid"] tbody tr[role="row"]');
    rows.unbind('click');
    rows.on('click', openRequest);
    rows.css('cursor', 'pointer');
};

const initGrid = () => {
    if (reqGridInitialized === true) return;
    const gridEle = $('.js-capital-expenditures-grid');
    reqGrid = gridEle.kendoGrid({
        dataSource : reqGridDs, columns: reqGridColumns, dataBound: reqGridDataBound, sortable: true, scrollable: true, filterable: {
            operators: {
                string   : {
                    contains: 'Contains', startswith: 'Starts with'
                }, number: {
                    gte: 'Greater than or equal to', lte: 'Less than or equal to', lt: 'Less than', gt: 'Greater than', eq: 'Equal to'
                }, date  : {
                    lt: 'Before', gt: 'After', eq: 'On', lte: 'Before or On', gte: 'After or On'
                }
            }
        }, pageable: {
            alwaysVisible: true, pageSizes: [5, 10, 25, 50, 'all'], buttonCount: 20
        }, toolbar : kendo.template($('#template-filter').html()), noRecords: {
            template: 'No capital expenditures to display.'
        }
    });
    reqGrid = gridEle.data('kendoGrid');
    reqGridInitialized = true;
};

const updatePendingFilter = (e) => {
    const currentFilter = reqGridDs.filter();
    if (currentFilter === undefined) {
        const baseFilter = {
            filters: [pendingFilter], logic: 'and'
        };
        reqGridDs.filter(baseFilter);
        return;
    }
    if (e.target.checked) {
        currentFilter.filters.push(pendingFilter);
    } else { // find index of pending and splice current filters to remove
        const pendingFilterIndex = currentFilter.filters.findIndex(f => f === pendingFilter);
        currentFilter.filters.splice(pendingFilterIndex, 1);
    }
    reqGridDs.filter(currentFilter);
};

const updateCreatedFilter = (e) => {
    const currentFilter = reqGridDs.filter();
    if (currentFilter === undefined) {
        const baseFilter = {
            filters: [myCreatedFilter], logic: 'and'
        };
        reqGridDs.filter(baseFilter);
        return;
    }
    if (e.target.checked) {
        currentFilter.filters.push(myCreatedFilter);
    } else { // find index of pending and splice current filters to remove
        const filterIndex = currentFilter.filters.findIndex(f => f === myCreatedFilter);
        currentFilter.filters.splice(filterIndex, 1);
    }
    reqGridDs.filter(currentFilter);
};

const initFilters = () => {
    if (extraFiltersInitialized === true) return;
    const pendingEle = $('input#myPending');
    const createdEle = $('input#myCreated');
    pendingEle.click(updatePendingFilter);
    createdEle.click(updateCreatedFilter);
    const roles = $('.js-filter-role');
    myCreatedFilter.filters.push({
        operator: 'eq', field: 'originator', value: $('.js-my-created-filter').val()
    });
    if (roles.length > 0) {
        roles.each((i, e) => {
            const role = $(e).text();
            const filter = {
                operator: 'contains', field: 'pendingApprovals', value: role
            };
            filterRoles.push(role);
            pendingFilter.filters.push(filter);
        });
        pendingEle.click();
    } else {
        pendingEle.parent().hide();
        createdEle.click();
    }
    extraFiltersInitialized = true;
};

const initWindow = () => {
    if (createWindowInitialized === true) return;
    const windowEle = $('#CapExCreateWindow');
    windowEle.kendoWindow({
        actions   : ['Close'], title: 'New Capital Expenditure Request', visible: false, maxWidth: 1080, maxHeight: 800, modal: true, scrollable: true, draggable: false, position: {
            top: 100, left: 100
        }, content: {
            template: $('#selection-window').html()
        }
    });
    createWindowInitialized = true;
};

export default function () {
    initGrid();
    initFilters();
    initWindow();
}
